import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description: "Here the tracker notices a receiver position change, then the filter chain updates.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/03/29/principle/principle-4.m4v`,
            },
          },
          styles: {
            padding: "2.5% 2%",
          },
        },
      },
    },
  },
};

export default principle;
